import { createSelector } from "reselect";

const selectProjectFiltersReducer = (state) => state?.projectFiltersReducer;

export const selectAppliedFilters = createSelector(
  selectProjectFiltersReducer,
  (projectFilters) => projectFilters?.appliedFilters ?? [],
);

/** useSelector((state) => selectAppliedFilterForTrackable(state, trackableId)) */
export const selectAppliedFilterForTrackable = (state, trackableId) => {
  if (trackableId == null) return null;
  const tid = Number(trackableId);
  const applied = selectAppliedFilters(state);
  return (
    applied.find((entry) =>
      (entry.appliedOnTrackableIds ?? []).some((id) => Number(id) === tid),
    ) ?? null
  );
};

/** Filter ids applied on this trackable (0 or 1 id per product rule). */
export const selectAppliedFilterIdsForTrackable = (state, trackableId) => {
  const applied = selectAppliedFilterForTrackable(state, trackableId);
  return applied?.id != null ? [applied.id] : [];
};

export const makeSelectProjectFilters = createSelector(
  selectAppliedFilters,
  (appliedFilters) => ({
    appliedFilters,
  }),
);